import { render, staticRenderFns } from "./truncate.vue?vue&type=template&id=4fe9a4ce&"
import script from "./truncate.vue?vue&type=script&lang=ts&"
export * from "./truncate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports